import MaskedInput from './masked-input';
import RifInput from '../masked-rif';
import IdentityInput from './identity-input';

export {RifInput, IdentityInput};
export default MaskedInput;
